export class NullLocalCopyException extends Error {
    constructor() {
        super(NullLocalCopyException.createMessage());
    }

    private static createMessage(): string {
        return "Local copy of the record is required for comparison.";
    }
}